var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalComparisonTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 4.8H6.8C6.32261 4.8 5.86477 4.98964 5.52721 5.32721C5.18964 5.66477 5 6.12261 5 6.6V17.4C5 17.8774 5.18964 18.3352 5.52721 18.6728C5.86477 19.0104 6.32261 19.2 6.8 19.2H13.1M16.7 4.8H17.6C18.0774 4.8 18.5352 4.98964 18.8728 5.32721C19.2104 5.66477 19.4 6.12261 19.4 6.6V7.5M19.4 16.5V17.4C19.4 17.8774 19.2104 18.3352 18.8728 18.6728C18.5352 19.0104 18.0774 19.2 17.6 19.2H16.7M19.4 11.1V12.9M12.2 3V21",
    stroke: "#EE3224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalComparisonTitle);
export default __webpack_public_path__ + "static/media/HospitalComparisonTitle.9d6a0b95a1cc1cdde132fbed3c04bebc.svg";
export { ForwardRef as ReactComponent };